import {APP_INITIALIZER, ErrorHandler, NgModule} from '@angular/core';
import {HttpClient, HttpClientModule} from '@angular/common/http';
import {BrowserModule} from '@angular/platform-browser';

import {AppComponent} from './app.component';

import {CoreModule} from '@core/core.module';
import {ThemeModule} from '@theme/theme.module';
import {RoutesModule} from './routes/routes.module';
import {SharedModule} from '@shared';
import {FormlyConfigModule} from './formly-config.module';
import {NgxPermissionsModule} from 'ngx-permissions';
import {ToastrModule} from 'ngx-toastr';
import {TranslateLoader, TranslateModule} from '@ngx-translate/core';

import {httpInterceptorProviders} from '@core/interceptors';
import {appInitializerProviders} from '@core/initializers';
import {registerLocaleData} from '@angular/common';
import localeDe from '@angular/common/locales/de';
import localeDeExtra from '@angular/common/locales/extra/de';

import * as Sentry from "@sentry/angular";
import {Router} from "@angular/router";
import {CustomTranslateLoaderService} from "@shared/services/translate/custom-translate-loader.service";
import {BrowserAnimationsModule} from "@angular/platform-browser/animations";

registerLocaleData(localeDe, localeDeExtra)

// Required for AOT compilation
export function TranslateHttpLoaderFactory() {
  return new CustomTranslateLoaderService();
}

@NgModule({
  declarations: [AppComponent],
  imports: [
    BrowserModule,
    HttpClientModule,
    CoreModule,
    ThemeModule,
    RoutesModule,
    SharedModule,
    FormlyConfigModule.forRoot(),
    NgxPermissionsModule.forRoot(),
    ToastrModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: TranslateHttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    BrowserAnimationsModule,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {
      },
      deps: [Sentry.TraceService],
      multi: true,
    },
    httpInterceptorProviders,
    appInitializerProviders,
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
}
